import Vue from 'vue';
import Vuex from 'vuex';
import user from "./User";
import auth from "./auth";
import exam from "./Exam";
import VuexPersistence from 'vuex-persist';

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
});

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [vuexLocal.plugin],
  modules: {
    user,auth,exam
  },
});